import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TReportsStore,
	TGetSalesReportsResponsePayload,
	TDownloadSalesReportResponsePayload,
	TGetVatReportsResponsePayload,
} from './types';

export const getReportsState = (state: TStoreState): TReportsStore => state.reports;

export const getReportsSelector = getReportsState;

// ==========================================:

export const getSalesReports = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): TGetSalesReportsResponsePayload => reports.salesReports,
);

// ==========================================:

export const getSalesReportsLoader = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): boolean => reports.salesReportsLoader,
);

// ==========================================:

export const getDownloadSalesReports = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): TDownloadSalesReportResponsePayload => reports.downloadSalesReport,
);

// ==========================================:

export const getDownloadSalesReportsLoader = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): boolean => reports.downloadSalesReportLoader,
);

// ==========================================:

export const getVatReports = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): TGetVatReportsResponsePayload => reports.vatReports,
);

// ==========================================:

export const getVatReportsLoader = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): boolean => reports.vatReportsLoader,
);

// ==========================================:

export const getDownloadVatReportsLoader = createSelector(
	[getReportsSelector],
	(reports: TReportsStore): boolean => reports.downloadVatReportLoader,
);

// ==========================================:
